import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { popPendingInvite } from "@/lib/invites";
import { toast } from "sonner";
import { Storefront } from "@phosphor-icons/react";

export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    // Emergent returns session_id in URL fragment
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) { setErr("Missing session_id"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/google", { session_id: sessionId });
        localStorage.setItem("mm_token", r.data.token);
        toast.success(`Signed in as ${r.data.user.name}`);
        // If user came through an invite link before Google sign-in, accept it now.
        const inviteToken = popPendingInvite();
        if (inviteToken) {
          try {
            await api.post("/invitations/accept", { token: inviteToken });
            toast.success("Invitation accepted — joined the team");
          } catch (e) {
            toast.error(e?.response?.data?.detail || "Invitation could not be accepted");
          }
        }
        // Reload so AuthProvider picks up the token (and joined business) cleanly.
        window.location.replace("/");
      } catch (e) {
        console.error("google auth", e);
        setErr(e?.response?.data?.detail || "Google sign-in failed");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--sand-50)]">
      <div className="text-center max-w-md fade-up">
        <div className="w-10 h-10 rounded-md bg-[var(--terracotta)] flex items-center justify-center mx-auto mb-4">
          <Storefront size={20} color="#fff" weight="fill" />
        </div>
        {!err ? (
          <>
            <div className="w-12 h-12 rounded-full border-4 border-[var(--sand-100)] border-t-[var(--terracotta)] animate-spin mx-auto mb-4" />
            <div className="label-eyebrow mb-1">Signing you in</div>
            <h1 className="font-heading text-xl font-semibold">Finishing up…</h1>
          </>
        ) : (
          <>
            <div className="label-eyebrow mb-1 text-[var(--destructive)]">Failed</div>
            <h1 className="font-heading text-xl font-semibold">{err}</h1>
            <button data-testid="google-cb-back" onClick={() => nav("/login")} className="mt-6 h-11 px-6 rounded-md bg-[var(--ink-900)] text-[var(--sand-50)] font-medium">Back to login</button>
          </>
        )}
      </div>
    </div>
  );
}
